import { validTableValue } from "../../utils/functions";
import { MUIStyled } from "../MUIStyled";
import SATypography from "../SATypography";

const StyledTarget = MUIStyled(SATypography)({
  fontWeight: 600,
  color: "#1F2937",
  backgroundColor: "#F3F4F6",
  padding: "4px 8px",
  borderRadius: "6px",
  display: "inline-block",
});

const SATarget = ({ value, variant }) => {
  if (!validTableValue(value))
    return <StyledTarget variant="body2">-</StyledTarget>;
  const numericValue = Number(value);
  return (
    <StyledTarget variant={variant || "body2"}>
      {numericValue < 1000
        ? `${numericValue.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 4,
          })} g`
        : `${(numericValue / 1000).toLocaleString(undefined, {
            maximumFractionDigits: 3,
          })} kg`}
    </StyledTarget>
  );
};

export default SATarget;
